module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Black.35bd0201.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Black.otf
// module id = 2412
// module chunks = 49